.tooltip {
  position: relative;
  display: inline-block;

  .tooltiptext {
    visibility: hidden;
    width: max-content;
    background-color: #555;
    color: #fff;
    text-align: center;
    font-family: var(--brand-date-font-family);
    font-size: 12px;
    border-radius: 5px;
    padding: 5px 10px;
    position: absolute;
    z-index: 1;
    transition:
      visibility 0.2s,
      opacity 0.2s ease-in-out;
    opacity: 0;
  }

  .top {
    bottom: 115%; /* Position above */
    left: 50%;
    transform: translateX(-50%);

    &::after {
      content: " ";
      position: absolute;
      top: 100%; /* At the bottom of the tooltip */
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #555 transparent transparent transparent;
    }
  }

  .bottom {
    top: 115%; /* Position below */
    left: 50%;
    transform: translateX(-50%);

    &::after {
      content: " ";
      position: absolute;
      bottom: 100%; /* At the top of the tooltip */
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent #555 transparent;
    }
  }

  .left {
    top: 50%;
    right: 90%; /* Position to the left */
    transform: translateY(-50%);

    &::after {
      content: " ";
      position: absolute;
      top: 50%;
      left: 100%; /* To the right of the tooltip */
      margin-top: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent transparent #555;
    }
  }

  .right {
    top: 50%;
    left: 90%; /* Position to the right */
    transform: translateY(-50%);

    &::after {
      content: " ";
      position: absolute;
      top: 50%;
      right: 100%; /* To the left of the tooltip */
      margin-top: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent #555 transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  &:active .tooltiptext {
    visibility: hidden;
    opacity: 0;
  }

  span:hover.tooltiptext {
    display: none;
  }
}
